import { TextField } from "../base/TextField";
import { IInitialPriceEstimateRequest } from "../../models/Category/InitialPriceEstimate";

interface BasicSettingsProps {
  config: IInitialPriceEstimateRequest;
  categoryEbayCategoryId: string | null;
  onChange: (patch: Partial<IInitialPriceEstimateRequest>) => void;
}

export default function BasicSettings({
  config,
  categoryEbayCategoryId,
  onChange,
}: BasicSettingsProps) {
  return (
    <section className="bg-white rounded shadow-sm border border-gray-200 p-4">
      <h2 className="text-xs font-semibold tracking-wide text-gray-500 uppercase mb-4">
        eBay Search
      </h2>

      <div className="space-y-4">
        <div>
          <TextField
            fullWidth
            label="Search keyword (optional)"
            placeholder="None"
            maxLength={100}
            value={config.searchKeyword ?? ""}
            onChange={(e) => onChange({ searchKeyword: e.currentTarget.value })}
          />
          <p className="mt-1 text-xs text-gray-500">
            Extra words added after the vehicle fields, such as the part name
            sellers use. Leave blank to search on the vehicle fields alone and
            let the eBay category pick out the part.
          </p>
        </div>

        <div>
          <TextField
            fullWidth
            label="eBay category id"
            inputMode="numeric"
            placeholder={categoryEbayCategoryId ?? "Not set on the category"}
            maxLength={20}
            value={config.ebayCategoryId ?? ""}
            onChange={(e) =>
              onChange({ ebayCategoryId: e.currentTarget.value.trim() })
            }
          />
          <p className="mt-1 text-xs text-gray-500">
            Narrows the search to one eBay category. Leave blank to use the
            category's own eBay id
            {categoryEbayCategoryId
              ? ` (${categoryEbayCategoryId})`
              : ", which is not set, so all categories are searched"}
            .
          </p>
        </div>

        <div>
          <TextField
            fullWidth
            type="number"
            min={0}
            label="Sort order"
            value={config.sortOrder}
            onChange={(e) => {
              const value = parseInt(e.currentTarget.value, 10);
              onChange({ sortOrder: Number.isNaN(value) ? 0 : Math.max(0, value) });
            }}
          />
          <p className="mt-1 text-xs text-gray-500">
            Lower numbers are priced, and shown on the lead, first.
          </p>
        </div>
      </div>
    </section>
  );
}
